// src/components/calculator/PayPalCalculator.tsx
import { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Calculator } from 'lucide-react';
import CalculatorForm from './CalculatorForm';
import ResultCard from './ResultCard';
import { CalculationResult } from '@/types/calculator';

const PayPalCalculator = () => {
  const [calculationResult, setCalculationResult] = useState<CalculationResult>({
    fees: '0.00',
    finalAmount: '0.00',
    rate: '0.00% + 0.00 €',
    baseAmount: '0.00'
  });

  return (
    <Card className="bg-white shadow-lg rounded-lg overflow-hidden">
      <div className="p-8">
        {/* Header Section */}
        <div className="flex items-center gap-3 mb-8 border-b pb-6">
          <Calculator className="h-8 w-8 text-blue-600" />
          <div>
            <h1 className="text-2xl font-bold text-gray-900">PayPal Gebührenrechner</h1>
            <p className="text-gray-600">Aktuelle Gebühren seit Januar 2025</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <CalculatorForm onCalculate={setCalculationResult} />
          </div>
          <div className="lg:col-span-1">
            <ResultCard result={calculationResult} />
          </div>
        </div>
      </div>
    </Card>
  );
};

export default PayPalCalculator;